import React from 'react';
import { Typography } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { ActivateButton, MapContextBar } from './StyledComponents';
import { useGame } from '../../context/GameContext';

const MapActivationContextBar = () => {
  const {
    maps,
    viewingMapId,
    currentMapId,
    isCreator,
    handleMapBarActivate,
  } = useGame();

  if (!isCreator || viewingMapId === currentMapId) {
    return null;
  }

  const activeMapName = maps.find((map) => map.id === viewingMapId)?.name || `Map (${viewingMapId})`;

  return (
    <MapContextBar>
      <Typography
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          fontSize: '0.9rem',
          fontFamily: 'MedievalSharp',
          color: theme.palette.secondary.main,
          '& em': {
            color: theme.palette.secondary.light,
          },
        })}
      >
        <MapIcon sx={{ mr: 1, fontSize: '1.1rem' }} />
        <strong style={{ marginLeft: '4px' }}>{activeMapName}</strong>
        <span style={{ margin: '0 8px', opacity: 0.6 }}>-</span>
        <em>not visible to players</em>
      </Typography>

      <ActivateButton onClick={handleMapBarActivate}>
        <PlayArrowIcon />
        Activate
      </ActivateButton>
    </MapContextBar>
  );
};

export default MapActivationContextBar;
